import React from 'react';
import lang from '../lang';

type ScreenProps = {
  lang: typeof lang.linkInvite;
};

export type LinkInviteScreenType = React.ComponentType<ScreenProps>;

export const LinkInvite = ({children}: {children: LinkInviteScreenType}) => {
  const Screen = children;
  return <Screen lang={lang.linkInvite} />;
};
